<template>
    <div>
        <div class="card accordion"
            :id="`accordion_${pIdx}`"
            v-for="(group, pIdx) in groups"
            :key="pIdx">
            <div class="card-header">
                <div class="row no-gutters">
                    <div class="col"
                        data-toggle="collapse"
                        :id="`heading_${group.id}_${pIdx}`"
                        :data-target="`#collapse_${group.id}_${pIdx}`"
                        :aria-controls="`collapse_${group.id}-${pIdx}`">
                        {{ group.name }}
                    </div>
                </div>
            </div>
            <div
                class="collapse"
                :id="`collapse_${group.id}_${pIdx}`"
                :aria-labelledby="`heading_${group.id}_${pIdx}`"
                >

                <div class="card-body">
                    <div
                        class="card accordion"
                        :class="{'mt-3': cIdx == 0, 'mb-3': group.kinds.length == 0 || (cIdx == group.kinds.length-1)}"
                        v-for="(child, cIdx) in group.kinds"
                        :key="`accordion_${group.id}_${cIdx}`">
                        <div class="card-header">
                            <div class="row no-gutters">
                                <div class="col"
                                    data-toggle="collapse"
                                    :id="`heading_child_${child.id}_${cIdx}`"
                                    :data-target="`#collapse_child_${child.id}_${cIdx}`"
                                    :aria-controls="`collapse_child_${child.id}-${cIdx}`">
                                    {{child.name}}
                                </div>
                            </div>
                        </div>
                        <div
                            class="collapse"
                            :id="`collapse_child_${child.id}_${cIdx}`"
                            :aria-labelledby="`heading_child_${child.id}_${cIdx}`"
                            >

                            <div class="card-body">
                                <div class="card-body py-3">
                                    <div
                                        class="form-check city-form-check px-0 px-sm-2 mb-1"
                                        v-for="typeItem in child.types"
                                        :key="`type-${typeItem.id}`">

                                        <input class="form-check-input"
                                            type="checkbox"
                                            :disabled="readonlyFormItem"
                                            v-model="mutableValue"
                                            :value="{id: typeItem.id}"
                                            :id="`checktype_${typeItem.id}`"
                                            :name="`checktype_${typeItem.id}`"
                                            v-validate="" />
                                        <label class="form-check-label" :for="`checktype_${typeItem.id}`">
                                            {{ typeItem.name }}
                                        </label>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import index from './mixins/index'

export default {
    mixins: [index],
    name: 'TypesList',
    props: {
        moduleId: {
            type: String,
            required: true
        },
        readonlyFormItem: {
            type: Boolean,
            default: true
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data() {
        return {
            pageID: 'types',
            mutableValue: [],
        }
    },
    mounted()
    {

    },
	watch: {
		value (newValue, oldValue) {
			this.mutableValue = newValue;
		},
		mutableValue (newValue, oldValue) {
			this.onChange ? this.onChange(newValue) : null;
		},
	},
    computed: {
        groups() {
            return this.data || [];
        },
    },
    methods: {
		onChange (newValue) {
			this.$emit('input', newValue);
		},
    },
}
</script>

<style>

</style>